<template>
  <div>
    <div class="title">权限设置</div>
    <div class="permissionMain">
      <PermissionItem
        v-for="(formItem, index) in formData"
        :key="formItem.id"
        :formItem="formItem"
        :title="index == 0 ? '默认角色' : `角色${index + 1}`"
        :validate="validate"
      />
      <Button class="addRole" icon="md-add" type="primary" @click="addRoles">新增角色</Button>
    </div>
  </div>
</template>
<script>
import PermissionItem from './PermissionItem.vue';
export default {
  name: 'GeneralSetting',
  components: { PermissionItem },
  data() {
    return {
      formData: [
        { id: 1, role: '', permission: [], colPermission: '' },
        { id: 2, role: '', permission: [], colPermission: '' }
      ],
      validate: {
        role: [{ required: true, message: '错误' }],
        permission: [{ type: 'array', required: true, message: '错误' }],
        colPermission: [{ required: true, message: '错误' }]
      }
    };
  },
  methods: {
    addRoles() {
      const data = [...this.formData];
      let lastId = data[data.length - 1].id;
      lastId++;
      data.push({ id: lastId, role: '', permission: [], colPermission: '' });
      this.formData = data;
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: 16px;
  margin-bottom: 10px;
}
.addRole {
  width: 100%
}
</style>
